<button 
  mat-icon-button 
  [color]="color"
  class="delete-button" 
  (click)="onClick()"
  [disabled]="disabled"
  [matTooltip]="tooltip"
  [matTooltipPosition]="tooltipPosition">
  <mat-icon>delete</mat-icon>
</button>
